import styled from 'styled-components'

import Button from '@/components/Button'

interface Props {
  disabled?: boolean
  alternate?: boolean
}

export const DangerButton = styled(Button)`
  background-color: ${(p: Props) =>
    p.disabled ? '#f2f2f2' : p.alternate ? 'transparent' : '#ed1c24'};
  width: 100%;
`

export default DangerButton
